import { Component, Input, Output } from "angular-ts-decorators";
import { FacilitiesModal } from "./Facilities.modal.component";
import { IAddress } from "../../../models/IAddress";
import { IFacility } from "../../../models/IFacility";
import { IRoleInfo } from "../../../models/IRoleInfo";
import { ITeam } from "../../../models/ITeam";
import { IUser } from "../../../models/IUser";
import { PermissionsService } from "../../../services/PermissionsService";
import { StaffManager } from "../staff/StaffManager.component";
import { TeamService } from "../../../services/TeamService";
import { UIComponent } from "../../../core/UIComponent";
import template from "./Facilities.template.html";

@Component({
  selector: "stFacilities",
  template,
})
export class Facilities extends UIComponent {
  static $inject: string[] = [
    "TeamService",
    "PermissionsService",
    "$uibModal",
    "$sce",
  ];
  @Input() team: ITeam;
  @Input() user: IUser;
  @Input() roles: IRoleInfo;
  @Input() mode: string;

  facilities: IFacility[];
  /**
   * Creates an instance of StaffManager.
   *
   * @param {TeamService} teamService
   * @param {angular.ui.bootstrap.IModalService} $uibModal
   *
   * @memberOf StaffManager
   */
  constructor(
    private teamService: TeamService,
    private permissionsService: PermissionsService,
    private $uibModal: angular.ui.bootstrap.IModalService,
    private $sce: angular.ISCEService
  ) {
    super();
  }

  private openModal(resolver: any): ng.IPromise<IFacility> {
    return this.modal<IFacility>(
      this.$uibModal,
      require("./Facilities.modal.template.html").default,
      FacilitiesModal,
      resolver
    );
  }

  /**
   *
   *
   *
   * @memberOf VideosComponent
   */
  add() {
    let me = this;
    me.openModal({
      item() {
        return {};
      },
    }).then(function (result: IFacility) {
      me.teamService
        .addFacility(me.team, result)
        .then((item) => me.facilities.push(item));
    });
  }

  /**
   *
   *
   * @param {IFacility} video
   *
   * @memberOf VideosComponent
   */
  edit(item: IFacility) {
    let me = this;
    me.openModal({
      item() {
        return item;
      },
    }).then((result) => me.teamService.updateFacility(me.team, result));
  }

  /**
   *
   *
   * @param {IVideo} video
   *
   * @memberOf VideosComponent
   */
  remove(item: IFacility) {
    if (!confirm("are you sure you want to remove this facilty?")) return false;
    let me = this;
    me.teamService.removeFacility(me.team, item);
    let idx = me.facilities.indexOf(item);
    if (idx >= 0) me.facilities.splice(idx, 1);
  }

  /**
   *
   *
   * @param {IAddress} location
   * @returns
   *
   * @memberOf Facilities
   */
  mapUrl(location: IAddress) {
    let addressString: string = "{street} {city} {state}, {zip}"
      .replace("{street}", location.street || "")
      .replace("{city}", location.city || "")
      .replace("{state}", location.state || "")
      .replace("{zip}", location.zip);
    let url: string =
      "https://www.google.com/maps/embed/v1/search?q={address}&key=AIzaSyBmLgI11kbyhMm3ggHgV9_Ged41jFWTQcc".replace(
        "{address}",
        encodeURIComponent(addressString)
      );
    return this.$sce.trustAsResourceUrl(url);
  }

  $onChanges(changesObj) {
    let me = this;
    if (me.team) {
      me.teamService
        .getFacilities(me.team)
        .then((facilities) => (me.facilities = facilities));
    }
  }
}
